import { useEffect } from "react";

/**
 * Hook to set up CSS animations needed for the chat UI
 */
export const useAnimations = () => {
  useEffect(() => {
    // Create and inject animation keyframes
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      
      @keyframes pulsate {
        0% { 
          transform: scale(1);
          opacity: 0.8;
        }
        50% { 
          transform: scale(1.3);
          opacity: 1;
        }
        100% { 
          transform: scale(1);
          opacity: 0.8;
        }
      }
      
      @keyframes blink {
        0%, 50% { opacity: 1; }
        51%, 100% { opacity: 0; }
      }
      
      @keyframes fadeIn {
        from { 
          opacity: 0;
        }
        to { 
          opacity: 1;
        }
      }
      
      @keyframes scaleIn {
        from { 
          transform: scale(0.9);
          opacity: 0;
        }
        to { 
          transform: scale(1);
          opacity: 1;
        }
      }
      
      @keyframes gentlePulse {
        0%, 100% { 
          transform: scale(1);
          opacity: 1;
        }
        50% { 
          transform: scale(1.05);
          opacity: 0.9;
        }
      }
    `;
    document.head.appendChild(styleElement);

    // Clean up on unmount
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);
};
